<template>
	<section class="" id="services">
		<div class="container px-4 px-lg-5">
			<h2 class="text-center mt-0">喜欢二次元的宅宅程序员o(´^｀)o</h2>
			<hr class="divider" />
			<div class="row gx-4 gx-lg-5">
				<div v-for="(item, key) in data" :key="key" class="col-lg-3 col-md-6 text-center">
					<div class="mt-5">
						<div class="mb-2">
							<i :class="item[0] + ' fs-1 text-primary'"></i>
						</div>
						<h3 class="h4 mb-2">{{ item[1] }}</h3>
						<p class="text-muted mb-0">{{ item[2] }}</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import data from "../data/data.json";
	export default {
		mame: "Services",
		data() {
			return {
				data: data.information,
			};
		},
	};
</script>

<style scoped>
	.container {
		min-height: 100vh;
		padding: 82px;
	}

	#services {
		min-height: 100vh;
		background: linear-gradient(to bottom,
				rgba(92, 77, 66, 0.8) 0%,
				rgba(92, 77, 66, 0.8) 100%),
			url("../assets/Background/background-2.png");
		background-position: top;
		background-repeat: no-repeat;
		background-attachment: scroll;
		background-size: cover;
	}

	.text-center {
		color: rgba(255, 255, 255);
	}

	.text-muted {
		color: rgba(255, 255, 255, 0.8) !important;
	}

	.h4 {
		color: rgba(255, 255, 255);
	}
</style>
